import { $_app_server } from '@/_helpers'

export const langService = {
  list,
  search,
  suggestion
}

function list() {
  return $_app_server.get("public/dictionary")
    .then(response => {
        return response.data
    })
}

function search(filter) {
  return $_app_server.post("public/dictionary/search",filter)
    .then(response => {
        return response.data
    })
}

function suggestion(filter) {
  return $_app_server.post("public/dictionary/suggestion",filter)
    .then(response => {
        return response.data
    })
}